
{
  "no-data-title": "No menu items found"
}
